module.exports = __webpack_public_path__ + "static/fast_quote.50ce1aea.svg";